module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746f_banner_800x600.6c4b1556.png";